module.exports = __webpack_public_path__ + "img/related_skills_black_icon.1ff4fe4d.svg";